import { useState } from 'react';

const useRecordAttendanceAction = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClickRecordAttendance = () => {
    setIsOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsOpen(false);
  };

  return { isOpen, handleClickRecordAttendance, handleCloseDrawer };
};

export default useRecordAttendanceAction;
